import React from 'react';

const SVG = ({
  style = {},
  fill = '#af1b1b',
  viewBox = '0 0 18 18',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill}> 
      <path d="M9 0L0 9l9 9 9-9zm1.125 13.5h-2.25v-2.25h2.25zm-2.25-3.375V4.5h2.25v5.625z"/> 
    </g>
  </svg>
);
export default SVG;